/* <media-gallery>: click a thumbnail, or step with the rail arrows, to show the matching media item. */
class MediaGallery extends HTMLElement {
  connectedCallback() {
    this.viewer = this.querySelector('[data-media-viewer]');
    this.thumbList = this.querySelector('[data-media-thumbs]');
    this.addEventListener('click', (event) => {
      const thumb = event.target.closest('[data-media-thumb]');
      if (thumb) {
        this.setActiveMedia(thumb.dataset.mediaId);
        return;
      }
      const arrow = event.target.closest('[data-media-step]');
      if (arrow) this.step(Number(arrow.dataset.mediaStep));
    });
  }

  thumbs() {
    return [...this.querySelectorAll('[data-media-thumb]')];
  }

  /* Moves the selection by `delta`, wrapping at either end. */
  step(delta) {
    const thumbs = this.thumbs();
    if (thumbs.length < 2) return;
    const current = thumbs.findIndex((thumb) => thumb.getAttribute('aria-current') === 'true');
    const next = (current + delta + thumbs.length) % thumbs.length;
    this.setActiveMedia(thumbs[next].dataset.mediaId);
  }

  /* Public: used by variant-picker.js to jump to the selected variant's image. */
  setActiveMedia(mediaId) {
    if (!mediaId) return;
    this.querySelectorAll('[data-media-item]').forEach((item) => {
      item.hidden = item.dataset.mediaId !== mediaId;
    });
    this.thumbs().forEach((thumb) => {
      const active = thumb.dataset.mediaId === mediaId;
      thumb.setAttribute('aria-current', active ? 'true' : 'false');
      if (active) this.revealThumb(thumb);
    });
  }

  /* Scrolls the rail (not the page) just enough to bring the thumbnail into view. */
  revealThumb(thumb) {
    const list = this.thumbList;
    if (!list) return;
    const listBox = list.getBoundingClientRect();
    const box = thumb.getBoundingClientRect();
    if (box.top < listBox.top) list.scrollTop -= listBox.top - box.top;
    else if (box.bottom > listBox.bottom) list.scrollTop += box.bottom - listBox.bottom;
    if (box.left < listBox.left) list.scrollLeft -= listBox.left - box.left;
    else if (box.right > listBox.right) list.scrollLeft += box.right - listBox.right;
  }
}
customElements.define('media-gallery', MediaGallery);
